import { useState } from "react";
import api from "./api";
import { useNavigate } from "react-router-dom";
import "./App.css";

export default function DeviceSearch() {
  const [deviceId, setDeviceId] = useState("");
  const [device, setDevice] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const searchDevice = async () => {
    if (!deviceId) {
      setError("Please enter a Device ID");
      return;
    }

    setError("");
    setLoading(true);
    setDevice(null);

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Session expired. Please login again.");
        navigate("/login");
        return;
      }

      const res = await api.get(
        `/api/devices/${deviceId}`,   // ✅ same-domain (cPanel safe)
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      // Backend returns array → take first row
      const data = Array.isArray(res.data) ? res.data[0] : res.data;
      setDevice(data);

    } catch (err) {
      console.error(err);

      if (err.response?.status === 401) {
        setError("Unauthorized. Please login again.");
        localStorage.clear();
        navigate("/login");
      } else if (err.response?.status === 404) {
        setError("Device not found");
      } else {
        setError("Failed to fetch device");
      }

    } finally {
      setLoading(false);
    }
  };

  const gotoEditDev = (e) => {
    e.preventDefault();
    navigate("/editdevdata", { state: { devId: deviceId } });
  };

  return (
    <div className="App-header">
      <h3>Device ID Search</h3>

      <input
        value={deviceId}
        onChange={(e) => setDeviceId(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && searchDevice()}
        placeholder="Enter Device ID"
      />

      <button onClick={searchDevice}>Search</button>

      {/* Loading */}
      {loading && <p>Searching...</p>}

      {/* Error */}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* Results */}
      {device && (
        <div>
          <table>
            <tbody>
              <tr>
                <td>Device ID:</td>
                <td>{device.deviceId}</td>
              </tr>
              <tr>
                <td>DU:</td>
                <td>{device.devDU}</td>
              </tr>
              <tr>
                <td>ALDS:</td>
                <td>{device.devADLS}</td>
              </tr>
              <tr>
                <td>DI:</td>
                <td>{device.devDI}</td>
              </tr>
              <tr>
                <td>MQTT Status:</td>
                <td>{device.mqttStatus}</td>
              </tr>
            </tbody>
          </table>

          <button onClick={gotoEditDev}>Edit</button>
        </div>
      )}
    </div>
  );
}